import { render, staticRenderFns } from "./ChildSelection.vue?vue&type=template&id=5d2544f1&scoped=true"
import script from "./ChildSelection.vue?vue&type=script&lang=js"
export * from "./ChildSelection.vue?vue&type=script&lang=js"
import style0 from "./ChildSelection.vue?vue&type=style&index=0&id=5d2544f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2544f1",
  null
  
)

export default component.exports